"use client";
import TrailerPlayer from '@/components/film/TrailerPlayer';
import { TrailerButtonMark1 } from "@/svg";
import { type Filmomtale, type Trailer } from '@filmweb/sanity-types';
import { useState } from 'react';
import styles from './TrailerContainer.module.css';



//#region [Props]
type TrailerContainerProps = {
    filmomtale: Filmomtale;
};
//#endregion

//#region [Component]
export default function TrailerContainer({ filmomtale }: TrailerContainerProps) {
    const [isShowingTrailer, setIsShowingTrailer] = useState(false);

    const trailer = filmomtale.trailers?.[0];

    if (!trailer) {
        return null;
    }

    return <>
        {!isShowingTrailer && <button className={styles.trailerPlayButton} onClick={() => setIsShowingTrailer(true)} title="Spill av trailer" type="button">
            <TrailerButtonMark1 />
        </button>}

        {isShowingTrailer && <div className={styles.trailerBackground} onClick={() => setIsShowingTrailer(false)}>
            <TrailerPlayer clipId={(trailer as Trailer).videoId} trailerClose={() => setIsShowingTrailer(false)} />
        </div>}
    </>

}
//#endregion